import _ from 'lodash';

import { Service, ServicesMap } from '@zapier/services/esm/types';

const getServiceByKey = (
  services: ServicesMap | Service[],
  serviceKey: string | null | undefined
) => {
  return _.find(services, ({ key }) => key === serviceKey);
};

export default getServiceByKey;
